import { render, staticRenderFns } from "./NationalPatentHistoryList.vue?vue&type=template&id=168e40bc&"
import script from "./NationalPatentHistoryList.vue?vue&type=script&lang=js&"
export * from "./NationalPatentHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentHistoryList.vue?vue&type=style&index=0&id=168e40bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports